import api from './api';
import type { AuthTokens, User } from '@trading/shared';

export const authService = {
  async login(email: string, password: string): Promise<AuthTokens> {
    const response = await api.post<AuthTokens>('/auth/login', {
      email,
      password,
    });
    return response.data;
  },

  async register(
    email: string,
    password: string,
    name: string,
    language?: string
  ): Promise<{ email: string; message: string }> {
    const response = await api.post<{ email: string; message: string }>(
      '/auth/register',
      { email, password, name, language }
    );
    return response.data;
  },

  async verifyEmail(token: string): Promise<AuthTokens> {
    const response = await api.post<AuthTokens>('/auth/verify-email', { token });
    return response.data;
  },

  async resendVerification(email: string): Promise<void> {
    await api.post('/auth/resend-verification', { email });
  },

  async requestMagicLink(email: string): Promise<void> {
    await api.post('/auth/magic-link', { email });
  },

  async magicLogin(token: string): Promise<AuthTokens> {
    const response = await api.post<AuthTokens>('/auth/magic-login', { token });
    return response.data;
  },

  async logout(accessToken: string, refreshToken: string): Promise<void> {
    await api.post(
      '/auth/logout',
      { refreshToken },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
  },

  async refreshToken(refreshToken: string): Promise<AuthTokens> {
    const response = await api.post<AuthTokens>('/auth/refresh', {
      refreshToken,
    });
    return response.data;
  },

  async getMe(accessToken: string): Promise<User> {
    const response = await api.get<User>('/auth/me', {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  },

  async forgotPassword(email: string): Promise<void> {
    await api.post('/auth/forgot-password', { email });
  },

  async resetPassword(token: string, password: string): Promise<void> {
    await api.post('/auth/reset-password', { token, password });
  },

  async checkEmail(email: string): Promise<{ exists: boolean; authProvider?: string }> {
    const response = await api.get<{ exists: boolean; authProvider?: string }>(
      '/auth/check-email',
      { params: { email } }
    );
    return response.data;
  },
};
